export default "__VITE_ASSET__BtNH7ARg__$_?url__"